"use client";

import { createContext } from "react";

/**
 * A function that returns `true` if navigation should be blocked.
 */
export type NavigationActionInterceptor = () => boolean;

export type NavigationActionInterceptorState = {
  /**
   * Registers an interceptor that can block navigation actions.
   * Returns a cleanup function to unregister the interceptor.
   */
  registerInterceptor: (interceptor: NavigationActionInterceptor) => () => void;

  /**
   * Requests navigation. If any registered interceptor blocks,
   * a confirmation modal is shown before proceeding.
   */
  requestNavigation: (callback: () => void) => void;
};

export const NavigationActionInterceptorContext = createContext<
  NavigationActionInterceptorState | undefined
>(undefined);
